export enum ImportSource {
	NOTION = 'Notion',
	MIRO = 'Miro',
	MURAL = 'Mural',
}

export const getIsWhiteboardSource = (importSource: string) => {
	return [ImportSource.MIRO, ImportSource.MURAL]
		.map((source) => source.toLowerCase())
		.includes(importSource.toLowerCase());
};

export const getImportSourceEnum = (importSource: string) => {
	const normalizedInput = importSource.toLowerCase();

	for (const source of Object.values(ImportSource)) {
		if (normalizedInput.includes(source.toLowerCase())) {
			return source;
		}
	}
	return undefined;
};
